<div class="support-channels-component">
  <div class="header d-flex justify-content-between">
    <h2 class="title">{{ title }}</h2>
    <mat-icon class="icon-close-btn pointer" (click)="close()" svgIcon="close"></mat-icon>
  </div>
  <p>Conheça todos os nossos canais de atendimento para que você tire suas dúvidas de forma rápida e eficiente.</p>
  <mat-divider *ngIf="suportChannels?.primary?.length > 0"></mat-divider>
  <div class="contact-channel" *ngIf="suportChannels?.primary?.length > 0">
    <div class="contact-channel-item d-flex align-items-center" *ngFor="let channel of suportChannels?.primary">
      <mat-icon *ngIf="channel?.contact" [svgIcon]="channel?.icon"></mat-icon>
      <div>
        <span *ngIf="channel?.contact">{{ channel?.description }}</span><br>
        <strong *ngIf="channel?.contact">{{ channel?.contact }}</strong>
      </div>
    </div>
  </div>
  <ng-container *ngIf="suportChannels?.others?.length > 0">
    <mat-divider></mat-divider>
    <h3 class="other-channels-title">Outros canais de atendimento</h3>
    <div class="other-channel-link" *ngFor="let channel of suportChannels?.others">
      <strong>{{ channel?.description }}</strong>
      <a [href]="channel?.link" target="_blank">{{ channel?.linkText }}</a>
    </div>
  </ng-container>
</div>
